<template>
	<div v-show="is_show" style="background-color: #FFF3E8;">
		<!-- <naviBack title="五星酒店SPA权益" type="nav1" background="#FFFFFF"  /> -->
		<van-image class="ma_img1" src="https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20250613_lytRA9ovsCN007s.png" />
		<van-image class="ma_img2" src="https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20250613_dCGe4vuyK31Tkng.png" />
		
		<!-- <div @click="toLink('venus_list')" class="ma_img3">
			<div class="ma_img31">
				<div>
					<div>酒店</div>
					<div>列表</div>
				</div>
			</div>
		</div> -->
		
		<div class="ma_bottom">
			<div @click="toList()">开启奢宠之旅</div>
		</div>
	</div>
</template>
<script>
	import naviBack from '../components/navi_back.vue';
	export default {
		components: {
			naviBack
		},
		data() {
			return {
				is_show:false
			}
		},
		mounted() {
			// location.reload()
			console.log(window.location.href);
			if(!sessionStorage.getItem('token')){
				return
			}
			this.getUserInfo()
			
		},
		methods: {
			toLink(e){
				this.$router.push({
					name:e
				})
			},
			getLocation(){
				return
				// 检查浏览器是否支持地理位置API
				if (!navigator.geolocation) {
				  // showError('您的浏览器不支持地理位置API');
				  alert('您的浏览器不支持地理位置API')
				  return;
				}
				
				// 配置地理位置选项
				const options = {
				  enableHighAccuracy: true,  // 尝试获取更精确的位置
				  timeout: 15000,             // 超时时间（毫秒）
				  maximumAge: 0              // 不使用缓存位置
				};
				
				// 获取当前位置
				navigator.geolocation.getCurrentPosition(
				  (position) => {
					alert(JSON.stringify(position))
					alert(position.coords.latitude,position.coords.longitude)
					  
				    // // 位置获取成功
				    // latitudeElement.textContent = position.coords.latitude.toFixed(6);
				    // longitudeElement.textContent = position.coords.longitude.toFixed(6);
				    // accuracyElement.textContent = `${position.coords.accuracy.toFixed(0)} 米`;
				    // locationResult.classList.remove('hidden');
				  },
				  (error) => {
				    // 位置获取失败
				    switch (error.code) {
				      case error.PERMISSION_DENIED:
				        alert('您拒绝了位置访问请求');
				        break;
				      case error.POSITION_UNAVAILABLE:
				        alert('位置信息不可用');
				        break;
				      case error.TIMEOUT:
				        alert('获取位置超时，请重试');
				        break;
				      case error.UNKNOWN_ERROR:
				        alert('发生未知错误，请重试');
				        break;
				    }
				  },
				);
			},
			getUserInfo(){
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getUserInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						$this.is_show=true
						$this.getLocation()
						if(res.data.url &&res.data.url=='order_detail'){
							$this.$router.push({
								name:res.data.url
							})
						}
					}).catch((error) => {
						console.warn(error)
						$this.$toast(error.msg?error.msg:error.message?error.message:"获取用户信息失败");
					})
			},
			toList(){
				if(!sessionStorage.getItem('token')){
					return
				}
				
				var agent = navigator.userAgent.toLowerCase();
				var isInsideWallet = ((new RegExp(/(com.unionpay.chsp)/).test(agent)) || (new RegExp(
					/(com.unionpay.mobilepay)/).test(agent)));
				if (isInsideWallet) {
					this.$router.push({
						name:'goods_list'
					})
				} else if (agent.match(/MicroMessenger/i) == "micromessenger") {
					this.$router.push({
						name:'tips'
					})
				}else{
					this.$router.push({
						name:'goods_list'
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.ma_img1{
		width: 100%;
		height: 100vh;
		// margin-top: 30*@vm_base;
	}
	.ma_img2{
		width: 100%;
		margin-top: 30*@vm_base;
	}
	.ma_img3{
		position: fixed;
		bottom: 400*@vm_base;
		right: 0;
		padding: 4*@vm_base 8*@vm_base 4*@vm_base 4*@vm_base;
		border-radius: 50% 0 0 50%;
		border: 1*@vm_base solid red;
		.ma_img31{
			width: 90*@vm_base;
			height: 90*@vm_base;
			border-radius: 50%;
			border: 1*@vm_base solid red;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28*@vm_base;
		}
	}
	.ma_bottom{
		position: sticky;
		bottom: 0;
		left: 0;
		margin-top: 50*@vm_base;
		width: 100%;
		background: #fff;
		box-shadow: -2*@vm_base -2*@vm_base 3*@vm_base rgba(243, 207, 166, 0.5);
		padding: 25*@vm_base 75*@vm_base;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		div{
			width: 100%;
			height: 80*@vm_base;
			background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 30*@vm_base;
			color: #FFFFFF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/main.vue